<fn-modal-header class="modal-header">
    <h5 class="modal-title">Execute Bulk Queries</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</fn-modal-header>
<mat-dialog-content class="mt-10">
    <div class="row m-0">
        <div class="col-12">
            <textarea placeholder="Type your single or multiple query(non-select) separated by semi-colon(';')... " alta-nice-scroll nice-option="{'horizrailenabled' : true}"
                [(ngModel)]="queryStr" rows="8" type="text" class="form-control resize-none"></textarea>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row">
        <div class="col-12">
            <fn-button [type]="'success'" btnClass="btn-sm btn-round width-100" [text]="'Execute
						Multiple Query'"
            ></fn-button>
        </div>
    </div>
</mat-dialog-actions>
